import { render, staticRenderFns } from "./FixOrderInfoCard.vue?vue&type=template&id=017e18dc&scoped=true&"
import script from "./FixOrderInfoCard.vue?vue&type=script&lang=ts&"
export * from "./FixOrderInfoCard.vue?vue&type=script&lang=ts&"
import style0 from "./FixOrderInfoCard.vue?vue&type=style&index=0&id=017e18dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017e18dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
